import React, { useCallback, useRef, useState } from "react";
import { AppBar, Box, Button, Dialog, DialogContent, Icon, IconButton, TextField, Toolbar, Typography } from "@mui/material";
import { useEffect } from "react";

export default function PartOrderComment(props) {
  const {open, handleClose, handleSubmit, title} = props;
   const [value, SetValue] = useState('')
   const [submitDisable, setSubmitDisable] = useState(true);

   const handleCommentChange = (event) => {
    SetValue(event.target.value);
   }

   useEffect(() => {
     if(value) {
      setSubmitDisable(false);
     } else {
      setSubmitDisable(true);
     }
   }, [value])
   

  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">{title}</Typography>
            <IconButton onClick={handleClose} color="inherit">
              <Icon>close</Icon>
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent classes={{ root: "p-16 sm:p-24" }}>
            <Box sx={{ mb: 2}}>
            <TextField
            id="outlined-textarea"
            label="Comment"
            placeholder="Write your comment here"
            multiline
            fullWidth
            rows={10}
            value={value}
            onChange={handleCommentChange}
            />
            </Box>
          <Button type="button" variant="contained" color="secondary" size="large" disabled={submitDisable} onClick={() => handleSubmit(value)}>
          Send to Customer
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
